<template>
  <div>
    <b-card
      class="light-style"
      footer-tag="footer"
    >
      <custom-loader v-if="loader" />
      <b-form v-else>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Button Text*">
            <b-input
              v-model="modalData.button_text"
              :class="{
                'is-invalid': $v.modalData.button_text.$error,
                'is-valid': !$v.modalData.button_text.$invalid,
              }"
              autocomplete="off"
              data-lpignore="true"
            />
            <b-form-invalid-feedback v-if="!$v.modalData.button_text.required">
              Button Text is required.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row class="pt-3">
          <b-form-group class="col" label="Button URL">
            <b-input v-model="modalData.button_url" autocomplete="off" data-lpignore="true" />
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group class="col">
            <span>
              <label class="switcher switcher-lg">
                <input
                  id="isVisibleApplyNow"
                  v-model="modalData.is_visible"
                  type="checkbox"
                  class="switcher-input"
                >
                <span
                  v-b-tooltip.hover.top="modalData.is_visible ? 'Disable Button' : 'Enable Button'"
                  class="switcher-indicator cursor-pointer"
                >
                  <span class="switcher-yes"><span class="ion ion-md-checkmark" /></span>
                  <span class="switcher-no"><span class="ion ion-md-close" /></span>
                </span>
              </label>
            </span>
          </b-form-group>
        </b-form-row>
      </b-form>
      <template #footer>
        <div class="d-flex justify-content-end align-items-center">
          <b-button
            variant="success"
            class="submit-btn"
            :disabled="loader"
            type="submit"
            @click="onSubmit($event)"
          >
            <b-spinner v-if="loader" />
            UPDATE
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import CustomLoader from '@/components/CommonPages/CustomLoader.vue'

export default {
  name: 'DetailApplyButtonForm',
  components: { CustomLoader },
  props: ['type', 'refId', 'modalData'],
  data () {
    return {
      loader: false
    }
  },
  methods: {
    onSubmit(event) {
      this.$v.$touch()
      event.preventDefault()
      if (this.$v.$invalid) {
        this.$toasted.global.error("Please fill out the required fields.")
      } else {
        this.loader = true
        this.$http.post(process.env.VUE_APP_API_URL + '/program_admin_toggle_rights/update_toggle', {
          program_admin_toggle_right: {
            page_name: this.type,
            is_visible: this.modalData.is_visible,
            button_text: this.modalData.button_text,
            button_url: this.modalData.button_url,
          },
          page_name: this.type,
        })
        .then((res) => {
          if(res === undefined){
            //this.$toasted.global.error('Process has been failed.')
          }else if (res.data.error !== undefined) {
            this.$toasted.global.error(res.data.error)
          } else {
            this.$toasted.global.success('Updated Successfully')
            this.hideModal()
            this.loader = false
          }
        })
      }
    },
    hideModal () {
      this.$root.$emit(`${this.refId}`)
    }
  },
  validations: {
    modalData: {
      button_text: {
        required
      }
    }
  }
}
</script>
